import './bootstrap'
import '../css/app.css'

import { createApp } from 'vue/dist/vue.esm-bundler.js'
import router from './routes/index.js'
import { installAxiosCasePlugin } from './plugins/axiosCase.js'
import { createPinia } from 'pinia'
import i18n from './plugins/i18n.js'
import Search from './views/search/Index.vue'
import Products from './views/products/Index.vue'
import Product from './views/product/Show.vue'
import FeaturedProduct from './components/shared/product/FeaturedProduct.vue'
import NewsletterForm from './components/shared/newsletter/NewsletterForm.vue'
import Cart from './views/cart/Index.vue'
import Checkout from './views/checkout/Index.vue'
import CheckoutSuccess from './views/checkout/Success.vue'
import CheckoutFailed from './views/checkout/Failed.vue'
import PaymentRequest from './views/payment/PaymentRequest.vue'
import EmptyCartPage from './views/Error.vue'
import Loading from './components/shared/Loading.vue'

installAxiosCasePlugin()

const app = createApp({
    components: {
        Search,
        Products,
        Product,
        FeaturedProduct,
        NewsletterForm,
        Cart,
        Checkout,
        CheckoutSuccess,
        CheckoutFailed,
        PaymentRequest,
        EmptyCartPage,
        Loading
    },
    delimiters: ['${', '}']
})
    .use(i18n)
    .use(createPinia())
    .use(router)
app.mount('#app')

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
    import.meta.hot.accept(() => {})
}
